export default __webpack_public_path__ + "static/bro_ids-7c7af86824738cbd26ddbe45ddc51a33.png";